import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablasPersonalizadasService from 'services/tablasPersonalizadas.service'

const OficinaFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue }) => {
  const __zariContext = React.useContext(ZariContext)
  const [areas, setAreas] = React.useState([])

  React.useEffect(() => {
    TablasPersonalizadasService.getAsSelect(TiposTablaPersonalizadaConstant.OFICINA)
      .then(({ data }) => setAreas(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  const onChange = e => {
    setFieldValue('_idOficinaSolicitante', e.target.value)
    setFieldValue('_idUsuarioSolicitante', '')
  }

  return (
    <Form.Group>
      <Form.Label text='OFICINA SOLICITANTE' htmlFor='select-oficinasolicitante' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idOficinaSolicitante'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-oficinasolicitante'
              onChange={onChange}
            >
              <option value=''>Seleccionar</option>
              {areas.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(OficinaFormGroup)
